import { CustomElement } from "../../core/CustomElement";
import Discussion from "../../core/interfaces/Discussion";

export default class DiscussionSearchVm {
  $discussionSearch: CustomElement;
  categoryId: number;
  itemsPerPage: number;
  discussions: KnockoutObservableArray<Discussion>;
  discussionsCount: KnockoutComputed<number>;
  page: KnockoutObservable<number>;
  displayPreviousBtn: KnockoutComputed<boolean>;
  displayNextBtn: KnockoutComputed<boolean>;

  constructor($customElement: CustomElement) {
    this.$discussionSearch = $customElement;
    this.itemsPerPage = 10;
    this.discussions = ko.observableArray();
    this.discussionsCount = ko.pureComputed(() => {
      return this.discussions().length;
    });
    this.page = ko.observable(1);
    this.displayPreviousBtn = ko.pureComputed(() => {
      return this.page() > 1;
    });
    this.displayNextBtn = ko.pureComputed(() => {
      return this.discussionsCount() === this.itemsPerPage;
    });
  }
}
